export const SECTION_ID = 'jira.plan';
